module.exports = __webpack_public_path__ + "static/media/general_without_detail_title.39972dd9.svg";